module.exports = __webpack_public_path__ + "assets/img/banner.ffd15080.svg";